<template>
  <div class="customState-effect">
    <div class="el-input-group el-input-group--append el-input-group--prepend">
      <div class="el-input-group__prepend">Scope</div>
      <el-select
        v-close-on-zoom
        :value="scope"
        :disabled="readonly"
        placeholder="Select Scope"
        @input="value => selectScope(value)"
      >
        <el-option
          v-for="aScope in availableScopes"
          :key="aScope.id"
          :label="aScope.label"
          :value="aScope.id"
        />
      </el-select>
      <div class="el-input-group__prepend el-input-group__append">set</div>
      <div>
        <el-select
          v-if="type === 'CUSTOM_ENUM_STATE'"
          v-close-on-zoom
          :value="state.effect.id"
          placeholder="Custom Enum State"
          class="customState-select"
          :disabled="readonly"
          @input="customStateId => selectCustomEnumState(customStateId)"
        >
          <el-option
            v-for="customState in availableStates"
            :key="customState.id"
            :label="customState.label"
            :value="customState.id"
          />
        </el-select>
        <el-select
          v-else
          v-close-on-zoom
          :value="state.effect.id"
          placeholder="Custom State"
          class="customState-select"
          :disabled="readonly"
          @input="customStateId => selectCustomState(customStateId)"
        >
          <el-option
            v-for="customState in availableStates"
            :key="customState.id"
            :label="customState.label"
            :value="customState.id"
          />
        </el-select>
      </div>
      <div class="el-input-group__append el-input-group__prepend">to</div>
      <div>
        <el-select
          v-if="type === 'CUSTOM_ENUM_STATE'"
          v-close-on-zoom
          :value="state.effect.value"
          :disabled="readonly"
          @input="value => updateCustomEnumStateValue(value)"
        >
          <el-option
            v-for="aValue in availableEnumValues"
            :key="aValue.id"
            :label="aValue.label"
            :value="aValue.id"
          />
        </el-select>
        <el-select
          v-else
          v-close-on-zoom
          :value="state.effect.value"
          :disabled="readonly"
          @input="value => updateCustomStateValue(value)"
        >
          <el-option label="True" :value="true" />
          <el-option label="False" :value="false" />
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import scopeMixins from '../utils/ScopeMixins';

export default {
  name: 'custom-state-effect',
  mixins: [ scopeMixins ],
  props: ['states', 'readonly', 'emitter', 'ikey', 'getData', 'putData', 'control', 'type'],
  data() {
    return {
      state: {
        effect: {
          id: null,
          value: this.type === 'CUSTOM_ENUM_STATE' ? null : true,
        },
        controlScope: null,
      },
      value: 0,
    };
  },
  computed: {
    customStates() {
      return this.emitter.caseConf.caseLogicDescription.customStates || [];
    },
    customEnumStates() {
      return this.emitter.caseConf.caseLogicDescription.customEnumStates || [];
    },
    activeStates() {
      if (this.type === 'CUSTOM_ENUM_STATE') {
        return this.customEnumStates;
      } else {
        return this.customStates;
      }
    },
    availableScopes() {
      const allScopeInfos = this.getAvailableScopes(this.emitter.caseConf);
      return allScopeInfos.filter(info => this.activeStates.find(state => state.scope === info.id));
    },
    availableStates() {
      return this.getAvailableStates(this.activeStates, this.scope);
    },
    availableEnumValues() {
      return this.getAvailableEnumValues(this.customEnumStates, this.state.effect.id);
    },
    scope() {
      if (this.state.effect.id) {
        if (this.type === 'CUSTOM_ENUM_STATE') {
          const customState = this.customEnumStates.find(state => state.id === this.state.effect.id);
          return customState ? customState.scope : null;
        } else {
          const customEnumState = this.customStates.find(state => state.id === this.state.effect.id);
          return customEnumState ? customEnumState.scope : null;
        }
      }
      return this.state.controlScope;
    },
  },
  mounted() {
    this.state.effect = this.getData(this.ikey) || this.state.effect;
    if (!this.state.effect.id) {
      // Default to first scope to save a click
      this.state.controlScope = this.availableScopes.length ? this.availableScopes[0].id : null;
    }
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    selectScope(scope) {
      this.state.controlScope = scope;
      this.state.effect.id = null;
      this.state.effect.value = null;
      this.update();
    },
    selectCustomState(customStateId) {
      this.state.effect.id = customStateId;
      this.update();
    },
    selectCustomEnumState(customEnumStateId) {
      this.state.effect.id = customEnumStateId;
      this.state.effect.value = null;
      this.update();
    },
    updateCustomStateValue(value) {
      this.state.effect.value = value;
      this.update();
    },
    updateCustomEnumStateValue(value) {
      this.state.effect.value = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: this.type,
        id: this.state.effect.id,
        value: this.state.effect.value,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.customState-select {
  width: 130px;
}

.customState-effect {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.duration-input {
  width: 125px;
}
</style>
